export type ModalIntroProps = {
  content: React.ReactNode;
};

export type ModalProps = {
  header?: any;
  footer?: React.ReactNode;
  children: any;
  show?: boolean;
  onShow?: () => void;
  onHide?: () => void;
  className?: string;
  size?: 'small' | 'medium' | 'large' | 'full'
  position?: "side" | "centered"; // default: "side"
  side?: "left" | "right" | "top" | "bottom";
  zPosition?: ZPosition;
  intro?: ModalIntroProps;
  /**
   * Siva podloga iza modala. Isključuje se kod čarobnjaka koji intro pale samo na nekim
   * koracima — na koraku bez introa podloga inače bljesne sivo pa se vrati.
   */
  showOverlay?: boolean;
};
export type ModalHeaderProps = {
  icon?: string;
  onHide?: () => void;
  title?: string;
  /** Oznaka uz naslov — npr. porijeklo dokumenta. Stoji odmah desno od naslova. */
  badge?: React.ReactNode;
};
export type ModalBodyProps = {
  children: any;
  overflow?: boolean;
  /**
   * Razmak na dnu za podnožja koja su `fixed` preko sadržaja. Modali s pravim
   * podnožjem (ModalFooter, WizardFooter) ga isključe — inače ostaje prazan pojas.
   */
  fixedFooterSpacing?: boolean;
};


export type ModalFooterProps = {
  children: any;
};


export enum ZPosition {
  Bottom = "bottom",
  Middle = "middle",
  Top = "top"
}

